import { jsx as _jsx } from "react/jsx-runtime";
import { AdSlotIds } from "@/shared/types";
import { AdContainer } from "./AdContainer";
import { useConfig } from "@/contexts/cdpConfig";
import { useFarbwelt } from "@/hooks";
import { useIsNewBuildProject } from "@/shared/hooks";
export const AdBannerMobile = () => {
    const { isFarbweltActive } = useFarbwelt();
    const isPreviewMode = useConfig().previewMode;
    const isProject = useIsNewBuildProject();
    if (isFarbweltActive || isPreviewMode || isProject) {
        return null;
    }
    return (_jsx(AdContainer, { adSlotId: AdSlotIds.AD_BANNER_MOBILE, width: "100%", height: "150px", display: {
            "breakpoint.base": "flex",
            "breakpoint.lg": "none",
        }, showLabel: true, showFallback: true }));
};
